module.exports = __webpack_public_path__ + "img/auto-4.4f8d4f29.png";